import React, { PropTypes } from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { createAdvice, updateAdvice } from 'funnel/actions/advice';
import AdviceForm from 'funnel/components/AdviceForm';

const addButtonLabel = props => (props.params.id ? 'Mettre à jour' : 'Créer');

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.params;
  return {
    current: id ? state.funnels.advices.items.get(id) : null,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  saveAdvice: fields => {
    const { id } = ownProps.params;
    if (id) {
      return dispatch(updateAdvice(id, fields));
    } else {
      return dispatch(createAdvice(fields));
    }
  },
});
class AdvicePage extends React.Component {
  static propTypes = {
    current: PropTypes.object,
    saveAdvice: PropTypes.func.isRequired,
  };

  render() {
    const { current } = this.props;

    return (
      <div className="ui clearing segment">
        <AdviceForm
          advice={current}
          label={addButtonLabel(this.props)}
          onSubmit={this.props.saveAdvice}
        />
      </div>
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  AdvicePage
);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/AdvicePage.js